import { ShieldCheck, Award, Users, Headphones, GraduationCap, FileCheck2 } from "lucide-react";
import { useT } from "@/i18n/LocaleProvider";

const ICONS = [ShieldCheck, Award, Users, Headphones, GraduationCap, FileCheck2];

export function CredibilityBar() {
  const t = useT();
  return (
    <section aria-label={t.credibility.aria} className="border-y border-white/5 bg-background/60 py-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
          {t.credibility.items.map((label, i) => {
            const Icon = ICONS[i];
            return (
              <li
                key={label}
                className="glass-card flex items-center gap-3 rounded-2xl px-4 py-3 text-xs font-medium"
              >
                <span className="gradient-primary inline-flex size-9 shrink-0 items-center justify-center rounded-xl text-white">
                  <Icon className="size-4" />
                </span>
                <span className="text-foreground/90">{label}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
